<template>
	<div :id="'course_'+id" class="comp course-item-comp"
		 @click="onCompClick">
		<div class="cover-wrap">
			<img class="cover-img"
				 v-lazy="cover" />
			<span class="format">{{ subfix }}</span>
		</div>
		<div class="info-wrap">
			<div class="title">{{ title }}</div>
			<div class="sub-title text--sub">
				<span v-if="!!author">{{`${author} · `}}</span>
				<span>{{position || ''}}</span>
			</div>
			<div class="price text--sub">{{ `${number}讲/￥${price}` }}</div>
			<div v-if="status === 1 || status === 2"
				 class="status-text"
				 :class="{ 'is-payed': status === 2 }">
				{{ `${status === 1 ? '待付款' : status === 2 ? '已付款' : ''}` }}
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'courseItem',
	props: [
		'id',
		'title',
		'subfix',
		'cover',
		'author',
		'position',
		'number',
		'price',
		'status',
		'beforeClick'
	],
	methods: {
		onCompClick() {
			if(!!this.beforeClick){
				this.beforeClick()
			}
			this.$router.push({
				name: 'courseDetail',
				query: { id: this.id, title: this.title, cover: this.cover }
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
.course-item-comp {
	display: inline-block;
	width: 330px;
	height: 400px;
	border-radius: 16px;
	box-shadow: #999 0px 0px 5px;
	overflow: hidden;

	.cover-wrap {
		height: 200px;
		position: relative;

		.cover-img {
			width: 100%;
			height: 100%;
		}

		.format {
			position: absolute;
			top: 0;
			right: 0;
			width: 107px;
			height: 54px;
			line-height: 54px;
			color: #fff;
			text-align: center;
			background: rgba(0, 0, 0, 1);
			border-radius: 0px 16px 0px 16px;
			opacity: 0.3011;
		}
	}

	.info-wrap {
		padding: 14px 26px 27px;
		position: relative;
		overflow: hidden;

		.title {
			font-weight: bold;
			height: 100px;
			font-size: 28px;
		}

		.sub-title {
			margin-bottom: 12px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.price {
			color: #8FC31E;
		}

		.status-text {
			position: absolute;
			right: -35px;
			bottom: 33px;
			width: 170px;
			height: 32px;
			line-height: 30px;
			text-align: center;
			font-size: 26px;
			color: #F8E71C;
			background-color: #543E3E;
			transform: rotate(-45deg);

			&.is-payed {
				background-color: #D0021B;
			}
		}
	}
}
</style>
